var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: 12.25,
  cy: 12,
  r: 12,
  fill: "#489F85"
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18.7288 7.88236L16.3313 5.47618C16.0184 5.1812 15.6084 5.01194 15.1792 5.00061C14.75 4.98927 14.3317 5.13665 14.0038 5.41471L6.12869 13.3182C5.84585 13.6045 5.66975 13.9797 5.62993 14.3808L5.25368 18.0428C5.24189 18.1714 5.25852 18.3011 5.30238 18.4225C5.34624 18.5439 5.41626 18.6542 5.50743 18.7453C5.58919 18.8267 5.68616 18.8911 5.79277 18.9348C5.89937 18.9785 6.01353 19.0007 6.12869 19H6.20744L9.85623 18.6663C10.2559 18.6263 10.6298 18.4496 10.915 18.1657L18.7901 10.2622C19.0957 9.93813 19.2609 9.50567 19.2494 9.05958C19.238 8.61349 19.0507 8.19017 18.7288 7.88236ZM9.69873 16.9099L7.0737 17.1558L7.30995 14.5213L12.2538 9.62114L14.6163 11.9922L9.69873 16.9099ZM15.7538 10.8154L13.4088 8.46195L15.115 6.70562L17.5038 9.10302L15.7538 10.8154Z",
  fill: "white",
  stroke: "#489F85",
  strokeWidth: 0.8
});

var SvgOnmoEdit = function SvgOnmoEdit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOnmoEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/onmo-edit.72a4be88.svg";
export { ForwardRef as ReactComponent };